import React from 'react'

import Checkbox from '../shapes/Checkbox'
import FlexGrid, { FlexCol } from '../structure/FlexGrid'
import Link from '../actions/Link'
import Panel from '../structure/Panel'
import Radio from '../shapes/Radio'
import Separator from '../helpers/Separator'
import { COLORS } from '@btime/constants'

const CardSelector = ({
  head,
  body,
  onClick,
  selected,
  useCheckbox,
  multiple,
  width,
  widthOnSm,
  disabled,
  ...props
}) => {
  const Marker = useCheckbox || multiple ? Checkbox : Radio

  return (
    <FlexCol width={width} widthOnSm={widthOnSm}>
      <Panel lineBorder smallPadding noMargin borderColor={selected && COLORS.purple} {...props}>
        <Link block onClick={onClick} disabled={disabled}>
          <Separator />
          <FlexGrid direction="column" justify="space-between" gutter={0.5} align="stretch" minHeight="7rem">
            <FlexCol flex={1}>
              <FlexGrid justify="space-between" gutter={0.5}>
                <FlexCol flex={1}>{head}</FlexCol>
                <FlexCol>
                  <Marker active={selected} />
                </FlexCol>
              </FlexGrid>
            </FlexCol>

            {body}
          </FlexGrid>

          <Separator />
        </Link>
      </Panel>
    </FlexCol>
  )
}

export default CardSelector
